export default __webpack_public_path__ + "static/cal2-b7925df8811dd299e12d35a6e9594bf9.png";